import {
  login,
  loginByWeixin,
  loginByMobile,
  logout,
  getUserInfo,
  getAgentUserInfo
} from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";

// 导入客户更新接口
/**
 * 客户全局存储模块
 */
const user = {
  state: {
    levels: {
      1100: '股东',
      1200: '院士',
      1300: '导师',
      1400: '总代',
      1500: '钻石VIP',
      1600: 'VIP',
    },
    userId: "",
    mobile: "",
    status: "",
    token: getToken(),
    username: "",
    avatar: "",
    roles: [],
    roleNames: [],
    countryCode: 86,
    createTime: "",
    lastTime: "",
    permissions: "",
    agentInfo: []
  },

  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_COUNTRYCODE: (state, countryCode) => {
      state.countryCode = countryCode;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_USERNAME: (state, username) => {
      state.username = username;
    },
    SET_LASTTIME: (state, lastTime) => {
      state.lastTime = lastTime;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_ROLENAMES: (state, roleNames) => {
      state.roleNames = roleNames;
    },
    SET_AGENTINFO: (state, agentInfo) => {
      console.log(state)
      state.agentInfo = agentInfo;
    },
    SET_NEWAGENTINFO: (state, newAgentInfo) => {
      state.newAgentInfo = newAgentInfo;
    }
  },

  actions: {
  //   // ----客户名登录---------
  //   login({ commit }, userInfo) {
  //     return new Promise((resolve, reject) => {
  //       login(userInfo)
  //         .then(data => {
  //           console.log("当前登录客户token信息===》");
  //           console.log(data);
  //           commit("SET_TOKEN", data.access_token);
  //           setToken(data, (data.expires_in / 24) * 60 * 60 * 1 * 1000);
  //           resolve();
  //         })
  //         .catch(error => {
  //           reject(error.resp_msg);
  //         });
  //     });
  //   },
  //   // --微信登录-----
  //   wxLogin({ commit }, params) {
  //     return new Promise((resolve, reject) => {
  //       loginByWeixin(params)
  //         .then(data => {
  //           console.log("当前登录客户token信息===》");
  //           console.log(data);
  //           commit("SET_TOKEN", data.access_token);
  //           setToken(data, (data.expires_in / 24) * 60 * 60 * 1 * 1000);
  //           resolve();
  //         })
  //         .catch(error => {
  //           reject(error.resp_msg);
  //         });
  //     });
  //   },
  //   // --手机短信登录-----
  //   mobileLogin({ commit }, params) {
  //     return new Promise((resolve, reject) => {
  //       loginByMobile(params)
  //         .then(data => {
  //           console.log("当前登录客户token信息===》");
  //           console.log(data);
  //           commit("SET_TOKEN", data.access_token);
  //           setToken(data, data.expires_in / 3600 / 24);
  //           resolve();
  //         })
  //         .catch(error => {
  //           reject(error.resp_msg);
  //         });
  //     });
  //   },
  //   // ----登录获取客户信息-------
  //   getUserInfo({ commit }) {
  //     return new Promise((resolve, reject) => {
  //       getUserInfo()
  //         .then(result => {
  //           // 由于mockjs 不支持自定义状态码只能这样hack
  //           console.log("当前登录客户信息=====》");
  //           console.log(result);
  //           const data = result.user;
  //           // console.log(data)
  //           const roles = ["agent"];
  //           const roleNames = ["经销商"];
  //           // 判断是否属于经销商账号
  //           if (!data.agentInfo || (data.agentInfo && !data.agentInfo.userId)) {
  //             return reject("您不是经销商客户不允许在此登录");
  //           }
  //           if (data.agentInfo.isBlacklist > 0) {
  //             return reject("您被列为黑名单，无法使用本系统。");
  //           }
  //           /*if (data.agentInfo.isAudit < 1) {
  //             return reject(
  //               "您的资料尚在审核中，请等待审核通过或联系上级经销商处理。"
  //             );
  //           }*/
  //           commit("SET_ROLES", roles);
  //           commit("SET_ROLENAMES", roleNames);
  //           commit("SET_USERNAME", data.username);
  //           commit("SET_USERID", data.userId);
  //           commit("SET_AVATAR", data.avatar);
  //           commit("SET_MOBILE", data.mobile);
  //           commit("SET_LASTTIME", data.lastTime);
  //           commit("SET_COUNTRYCODE", data.countryCode);
  //           commit("SET_AGENTINFO", data.agentInfo);
  //           // 返回权限
  //           //resolve(roles);
  //           // 返回客户信息
  //           resolve(data);
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //     });
  //   },
  //   // ------实时获取经销商客户最新信息（如库存+级别等-避免客户不及时显示导致一些疑问）-------
    getAgentUserInfo({ commit }) {
      console.log(commit)
      return new Promise((resolve, reject) => {
        getAgentUserInfo()
          .then(result => {
            // 由于mockjs 不支持自定义状态码只能这样hack
            console.log("当前经销商客户最新信息=====》");
            const data = result.datas;
            console.log(data);
            // 判断是否属于经销商账号
            if (!data) {
              return reject("您当前不是经销商客户");
            }
            if (data.isBlacklist > 0) {
              return reject("您被列为黑名单啦，无法使用本系统。");
            }
            commit("SET_AGENTINFO", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  //   // 定义更新客户信息
  //   saveUserInfo({ commit }, newUserInfo) {
  //     return new Promise((resolve, reject) => {
  //       saveUserInfo(newUserInfo)
  //         .then(response => {
  //           console.log("更新客户信息结果==》");
  //           console.log(response);
  //           if (response.resp_code === 1) {
  //             // 出错了
  //             // this.$message.error(response.resp_msg)
  //             reject(response.resp_msg);
  //           }
  //           // 更新本地存储
  //           const data = response.datas;
  //           commit("SET_USERNAME", data.username);
  //           commit("SET_AVATAR", data.avatar);
  //           commit("SET_COUNTRYCODE", data.countryCode);
  //           commit("SET_MOBILE", data.mobile);
  //           commit("SET_LASTTIME", data.lastTime);
  //           commit("SET_AGENTINFO", data.agentInfo);
  //           resolve(true);
  //         })
  //         .catch(response => {
  //           console.log(response);
  //           reject(response.resp_msg);
  //         });
  //     });
  //   },
  //   // 登出
  //   logOut({ commit, state }) {
  //     return new Promise((resolve, reject) => {
  //       logout(state.token)
  //         .then(() => {
  //           commit("SET_TOKEN", "");
  //           commit("SET_ROLES", []);
  //           removeToken();
  //           resolve();
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //     });
  //   },

  //   // 前端 登出
  //   fedLogOut({ commit }) {
  //     return new Promise(resolve => {
  //       commit("SET_TOKEN", "");
  //       removeToken();
  //       resolve();
  //     });
  //   },
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js